import React from 'react';
import {
  Modal,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import { EVENT_FILTER_LABELS } from '@/types/admin/events';
import { ADMIN_COLORS } from '@/constants/admin';
import { FilterModalProps } from './types';

export const FilterModal: React.FC<FilterModalProps> = ({ 
  visible, 
  filters, 
  onToggleFilter, 
  onClose 
}) => {
  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
    >
      <SafeAreaView style={styles.filterModalContainer}>
        <View style={styles.filterModalHeader}>
          <Text style={styles.filterModalTitle}>Filter Attendees</Text>
          <TouchableOpacity 
            style={styles.filterModalCloseButton} 
            onPress={onClose}
            accessibilityLabel="Close filter modal"
            accessibilityHint="Tap to close the filter options and return to attendee list"
            accessibilityRole="button"
          >
            <Text style={styles.filterModalCloseText}>Done</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.filterModalContent}>
          {EVENT_FILTER_LABELS.map((label) => (
            <TouchableOpacity
              key={label.key}
              style={styles.filterOption}
              onPress={() => onToggleFilter(label.key)}
              accessibilityLabel={`${label.title} filter`}
              accessibilityHint={`${filters[label.key] ? 'Currently enabled. Tap to disable' : 'Currently disabled. Tap to enable'} this filter option`}
              accessibilityRole="checkbox"
              accessibilityState={{ checked: filters[label.key] }}
            >
              <View style={styles.filterOptionContent}>
                <Text style={styles.filterOptionText}>{label.title}</Text>
                <View style={[
                  styles.filterCheckbox,
                  filters[label.key] && styles.filterCheckboxActive
                ]}>
                  {filters[label.key] && (
                    <Text style={styles.filterCheckboxCheck}>✓</Text>
                  )}
                </View>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </SafeAreaView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  filterModalContainer: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  filterModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  filterModalTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
  filterModalCloseButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  filterModalCloseText: {
    fontSize: 14,
    fontWeight: '600',
    color: 'white',
  },
  filterModalContent: {
    padding: 20,
  },
  filterOption: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER + '30',
  },
  filterOptionContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterOptionText: {
    fontSize: 16,
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
  filterCheckbox: {
    width: 24,
    height: 24,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: ADMIN_COLORS.BORDER,
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterCheckboxActive: {
    backgroundColor: ADMIN_COLORS.PRIMARY,
    borderColor: ADMIN_COLORS.PRIMARY,
  },
  filterCheckboxCheck: {
    fontSize: 14,
    fontWeight: '700',
    color: 'white',
  },
});
